// removed by extract-text-webpack-plugin
module.exports = {"Controls":"resourceTables__Controls__237uj","Search":"resourceTables__Search__2clUF","ResourceHeader":"resourceTables__ResourceHeader__gqToN","Row":"resourceTables__Row__3Q6Gs","Col":"resourceTables__Col__3VDBD"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Monitoring/resourceTables.css
// module id = 1689
// module chunks = 2